export default "__VITE_ASSET__B8HD6dTY__"